import { TeamStats } from "@/types"
import { getStatsColor, PRIORITY_COLOR_VALUES } from "@/utils"

import { TeamWithStats } from "../EventsStatistics/TeamStats"
import { EventsTableHeader } from "."

export function getPriorityReturnValue(a: TeamStats, b: TeamStats) {
  const aPriority = getStatsColor(a) || "success"
  const bPriority = getStatsColor(b) || "success"

  return PRIORITY_COLOR_VALUES[bPriority] - PRIORITY_COLOR_VALUES[aPriority]
}

export function sortEventsListColumn(column: EventsTableHeader, isSortedDesc: boolean) {
  const returnValue = isSortedDesc ? -1 : 1

  switch (column) {
    case "name":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) {
          const priorityReturnValue = getPriorityReturnValue(a.stats, b.stats)
          if (priorityReturnValue !== 0) return priorityReturnValue
        }

        return b.team.name.localeCompare(a.team.name, "pl") * returnValue
      }

    case "active_drivers_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) {
          const aInactiveDriversCount = a.stats.total_drivers_count - a.stats.active_drivers_count
          const bInactiveDriversCount = b.stats.total_drivers_count - b.stats.active_drivers_count
          
          const inactiveDriversCountValue = (aInactiveDriversCount - bInactiveDriversCount) * returnValue
          const activeDriversCountValue = (a.stats.active_drivers_count - b.stats.active_drivers_count) * returnValue

          return inactiveDriversCountValue === 0 ? activeDriversCountValue : inactiveDriversCountValue
        }

        return 0
      }

    case "blocked_drivers_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) return (a.stats.blocked_drivers_count - b.stats.blocked_drivers_count) * returnValue
        return 0
      }

    case "today_orders_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) return (a.stats.today_orders_count - b.stats.today_orders_count) * returnValue
        return 0
      }

    case "load_value":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) return (a.stats.load_value - b.stats.load_value) * returnValue
        return 0
      }

    case "late_drivers_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) return (a.stats.late_drivers_count - b.stats.late_drivers_count) * returnValue
        return 0
      }

    case "today_delivery_orders_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats)
          return (a.stats.today_delivery_orders_count - b.stats.today_delivery_orders_count) * returnValue
        return 0
      }

    case "unsettled_payments_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats)
          return (a.stats.unsettled_payments_count - b.stats.unsettled_payments_count) * returnValue
        return 0
      }

    case "dynamic_buffer_real_value":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats)
          return (a.stats.dynamic_buffer_real_value - b.stats.dynamic_buffer_real_value) * returnValue
        return 0
      }

    case "traffic_value":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) {
          const statsA = a.stats.traffic_value || 0
          const statsB = b.stats.traffic_value || 0

          return (statsA - statsB) * returnValue
        }
        return 0
      }

    case "omitted_orders_count":
      return (a: TeamWithStats, b: TeamWithStats) => {
        if (a.stats && b.stats) {
          return (a.stats.omitted_orders_count - b.stats.omitted_orders_count) * returnValue
        }
        return 0
      }
  }
}
